
function setCheckoutStateMachine(stateMachineId){
    var token = $("input[name='_csrf']").val();
    var header = "X-CSRF-TOKEN";
    $.ajax({
         url: '/checkout/state-machine?stateMachineId='+stateMachineId,
         beforeSend: function(xhr) {
                 xhr.setRequestHeader(header, token);
         },
         type: 'POST',
         success: function (response) {
            console.log("The change of state machine was successfully ! New state machine id : "+stateMachineId);
         },
         error: function (xhr, status, error) {
            console.error("Cannot set state machine with id: "+stateMachineId+". Reason: "+xhr.responseText);
         }
    });
}